"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcessibilidadeFonte = void 0;
var react_1 = require("react");
var useAcessibilidadeFonte = function () {
    var TAMANHO_PIXEL = 2;
    var TAMANHO_MINIMO_ESTADO = 2;
    var TAMANHO_MAXIMO_ESTADO = 10;
    var KEY_SESSION_STORAGE_TAMANHO_FONTE = 'acessibilidade-tamanho-fonte';
    var tamanhoFonteLocalStorage = parseInt(localStorage.getItem(KEY_SESSION_STORAGE_TAMANHO_FONTE) || '0');
    var _a = (0, react_1.useState)(tamanhoFonteLocalStorage), tamanhoFonteEstado = _a[0], setTamanhoFonteEstado = _a[1];
    var obterElementoAcessibilidade = function (callback) {
        var items = document.getElementsByClassName('acessibilidade');
        if (!items) {
            return;
        }
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var elementoHTML = items_1[_i];
            var style = window.getComputedStyle(elementoHTML, null).getPropertyValue('font-size');
            var fontSize = parseFloat(style);
            callback({
                fontSize: fontSize,
                elementoHTML: elementoHTML,
            });
        }
    };
    var aplicarTamanhoFonteLocalStorage = (0, react_1.useCallback)(function () {
        if (tamanhoFonteLocalStorage > 0) {
            obterElementoAcessibilidade(function (_a) {
                var fontSize = _a.fontSize, elementoHTML = _a.elementoHTML;
                var calculoFonte = fontSize + tamanhoFonteLocalStorage;
                elementoHTML.style.fontSize = calculoFonte + 'px';
            });
        }
    }, [tamanhoFonteLocalStorage]);
    var aplicarTamanhoFonteEmElementos = (0, react_1.useCallback)(function (estado) {
        obterElementoAcessibilidade(function (_a) {
            var fontSize = _a.fontSize, elementoHTML = _a.elementoHTML;
            if (estado === 'INCREMENTO' && tamanhoFonteEstado < TAMANHO_MAXIMO_ESTADO) {
                var calculoFonte = fontSize + TAMANHO_PIXEL;
                elementoHTML.style.fontSize = calculoFonte + 'px';
            }
            if (estado === 'DECREMENTO' && tamanhoFonteEstado >= TAMANHO_MINIMO_ESTADO) {
                var calculoFonte = fontSize - TAMANHO_PIXEL;
                elementoHTML.style.fontSize = calculoFonte + 'px';
            }
            localStorage.setItem(KEY_SESSION_STORAGE_TAMANHO_FONTE, tamanhoFonteEstado.toString());
        });
    }, [tamanhoFonteEstado]);
    var calcularFonteEstado = (0, react_1.useCallback)(function (estado) {
        if (estado === 'INCREMENTO' && tamanhoFonteEstado < TAMANHO_MAXIMO_ESTADO) {
            setTamanhoFonteEstado(tamanhoFonteEstado + TAMANHO_PIXEL);
        }
        if (estado === 'DECREMENTO' && tamanhoFonteEstado >= TAMANHO_MINIMO_ESTADO) {
            setTamanhoFonteEstado(tamanhoFonteEstado - TAMANHO_PIXEL);
        }
    }, [tamanhoFonteEstado]);
    var definirTamanhoFonte = (0, react_1.useCallback)(function (estado) {
        calcularFonteEstado(estado);
        aplicarTamanhoFonteEmElementos(estado);
    }, [aplicarTamanhoFonteEmElementos, calcularFonteEstado]);
    return {
        definirTamanhoFonte: definirTamanhoFonte,
        tamanhoFonteEstado: tamanhoFonteEstado,
        aplicarFonteLocalStorage: aplicarTamanhoFonteLocalStorage,
    };
};
exports.useAcessibilidadeFonte = useAcessibilidadeFonte;
